import { type MouseEvent } from 'react';
import { StyledHeartIcon } from './styles';
import {
  ConnectedSelectedHeartIcon,
  ConnectedStaticHeartIcon,
} from '@/components/account/uielements';

interface Props {
  label?: string;
  active?: boolean;
  onClick: (favorite: boolean) => void;
  favorites?: boolean;
}

const HeartIcon: React.FC<Props> = ({ label, active, onClick, favorites }) => {
  const handleClick = (e: MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    onClick(!active);
  };

  return (
    <StyledHeartIcon
      favorites={favorites}
      aria-label={label || 'Click to favorite'}
      onClick={handleClick}
    >
      {active ? <ConnectedSelectedHeartIcon /> : <ConnectedStaticHeartIcon />}
    </StyledHeartIcon>
  );
};

export default HeartIcon;
